/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import TeaserCard from "../Cards/TeaserCard/TeaserCard";
import React from "react";
import linkedCardBoxStyle from "./LinkedCardBoxStyle";
import _map from "lodash/map";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import useMediaQuery from "@mui/material/useMediaQuery";
import { Box, Theme } from "@mui/material";
import { IconWrapperProps } from "../IconWrapper/IconWrapper";

type LinkedCardBoxProps = {
  linkedCards: Array<{
    icon: IconWrapperProps["icon"];
    heading: string;
    subHeading?: string;
    link?: string;
    linkType?: string;
    hideMobileButton?: boolean;
  }>;
  cardButtonText?: string;
};

const LinkedCardBox = ({ linkedCards, cardButtonText = "Jetzt starten" }: LinkedCardBoxProps) => {
  const responsive = {
    xl: {
      breakpoint: { max: 5000, min: 1920 },
      items: Math.min(linkedCards.length, 4),
    },
    lg: {
      breakpoint: { max: 1919, min: 1280 },
      items: Math.min(linkedCards.length, 4),
    },
    md: {
      breakpoint: { max: 1279, min: 960 },
      items: Math.min(linkedCards.length, 3),
    },
    sm: {
      breakpoint: { max: 959, min: 600 },
      items: 2,
    },
    xs: {
      breakpoint: { max: 599, min: 0 },
      items: 1,
    },
  };

  const getAllItemsDisplayedBreakpoint = () => {
    switch (linkedCards.length) {
      case 2:
        return "sm";
      case 3:
        return "md";
      case 4:
      default:
        return "lg";
    }
  };

  const allItemsDisplayed = linkedCards.length <= 4 ? useMediaQuery((theme: Theme) => theme.breakpoints.up(getAllItemsDisplayedBreakpoint())) : false;

  //current responsive object only works if the area width is above 1100 otherwise cards overlap on smaller devices
  return (
    <Carousel responsive={responsive} draggable={false} arrows={false} autoPlay={false} showDots={!allItemsDisplayed} shouldResetAutoplay={false}>
      {_map(linkedCards, (card, key) => {
        return (
          <Box sx={linkedCardBoxStyle.cardContainer} key={key}>
            <TeaserCard
              icon={card.icon}
              heading={card.heading}
              subHeading={card.subHeading}
              linkTo={card.link}
              buttonText={cardButtonText}
              linkType={card.linkType}
              displayMobileButton={!card.hideMobileButton}
            />
          </Box>
        );
      })}
    </Carousel>
  );
};

export default LinkedCardBox;
